import { Page } from './page';

export class Chapter {
  subject: string;
  pages: Page[];
}
